import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import '../../style/CopyDialog.scss';
import queries from '../../queries';
import { apolloClient } from '../../config';
import { showToast } from '../../toast';
import { t } from '../../i18n';

const COPY_PAGE = gql`
  mutation CopyPageToProject($pageId: ID!, $projectId: ID!) {
    copyPageToProject(pageId: $pageId, projectId: $projectId) {
      id
      name
    }
  }
`;

const COPY_CELL = gql`
  mutation CopyCellToPage($input: ID!, $pageId: ID) {
    duplicateCell(input: $input, pageId: $pageId) {
      id
    }
  }
`;

// Copie une page ou un module vers une autre interface.
// Ouverture : window.dispatchEvent(new CustomEvent('tsk-open-copy', { detail: { mode: 'page' | 'cell', id, name } }))
class CopyDialog extends Component {

  state = { open: false, mode: 'page', id: null, name: '', projectId: '', pageId: '', busy: false };

  componentDidMount() {
    window.addEventListener('tsk-open-copy', this.open);
    window.addEventListener('keydown', this.onKey);
  }

  componentWillUnmount() {
    window.removeEventListener('tsk-open-copy', this.open);
    window.removeEventListener('keydown', this.onKey);
  }

  onKey = (e) => { if (e.key === 'Escape' && this.state.open) this.close(); };
  open = (e) => this.setState({ open: true, busy: false, projectId: '', pageId: '', ...e.detail });
  close = () => this.setState({ open: false });

  submit = async () => {
    const { mode, id, projectId, pageId } = this.state;
    this.setState({ busy: true });
    try {
      if (mode === 'page') {
        await apolloClient.mutate({ mutation: COPY_PAGE, variables: { pageId: id, projectId } });
        showToast(t('ui.copy.done_page'));
      } else {
        await apolloClient.mutate({ mutation: COPY_CELL, variables: { input: id, pageId } });
        showToast(t('ui.copy.done_cell'));
      }
      this.close();
    } catch (e) {
      this.setState({ busy: false });
      showToast(mode === 'cell' ? t('ui.copy.fail_cell') : t('ui.copy.fail_page'), 'error', 6000);
    }
  };

  render() {
    const { open, mode, name, projectId, pageId, busy } = this.state;
    if (!open) return null;
    const ready = mode === 'page' ? !!projectId : !!projectId && !!pageId;
    return (
      <div className='tsk-ui-modal-overlay' onMouseDown={this.close}>
        <div className='tsk-ui-modal-surface tsk-copy' role='dialog' aria-label={t('ui.copy.aria')} onMouseDown={(e) => e.stopPropagation()}>
          <h3 className='tsk-ui-modal__title'>{mode === 'page' ? t('ui.copy.title_page') : t('ui.copy.title_cell')} {name && <em>« {name} »</em>}</h3>
          <p className='tsk-settings-hint'>
            {mode === 'page'
              ? t('ui.copy.hint_page')
              : t('ui.copy.hint_cell')}
          </p>
          <Query query={queries.projects.list} fetchPolicy='cache-first'>
            {({ data }) => (
              <label className='tsk-copy__field'>
                <span>{t('ui.copy.dest_iface')}</span>
                <select value={projectId} onChange={(e) => this.setState({ projectId: e.target.value, pageId: '' })}>
                  <option value=''>{t('ui.copy.choose_iface')}</option>
                  {((data && data.projects) || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map((p) => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
              </label>
            )}
          </Query>
          {mode === 'cell' && projectId && (
            <Query query={queries.projects.projectPagesForCopy} variables={{ id: projectId }} fetchPolicy='network-only'>
              {({ data }) => (
                <label className='tsk-copy__field'>
                  <span>{t('ui.copy.dest_page')}</span>
                  <select value={pageId} onChange={(e) => this.setState({ pageId: e.target.value })}>
                    <option value=''>{t('ui.copy.choose_page')}</option>
                    {((data && data.project && data.project.pages) || []).map((p) => (
                      <option key={p.id} value={p.id}>{p.name}</option>
                    ))}
                  </select>
                </label>
              )}
            </Query>
          )}
          <div className='tsk-ui-modal__actions'>
            <button type='button' className='tsk-button' style={{ background: 'transparent', color: 'inherit', boxShadow: 'none', border: '1px solid var(--tsk-border)' }} onClick={this.close}>{t('ui.common.cancel')}</button>
            <button type='button' className='tsk-button' disabled={!ready || busy} onClick={this.submit}>{busy ? t('ui.copy.copying') : t('ui.copy.copy')}</button>
          </div>
        </div>
      </div>
    );
  }
}

export default CopyDialog;
